"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("reflect-metadata");

var ConverterTypeError_1 = require("./Error/ConverterTypeError");

var ClassLevel_1 = require("./TypeDecorator/ClassLevel");

var PrimitiveTypeEnum_1 = require("./TypeDecorator/PrimitiveTypeEnum");

var PropertyTypeDefinition_1 = require("./TypeDecorator/PropertyTypeDefinition");

var Util_1 = require("./Util");

function map(collection, cb) {
  return Array.prototype.map.call(collection, cb);
}

var Converter =
/** @class */
function () {
  function Converter(logger) {
    this.logger = logger;
  }
  /**
   * Convert a single raw object into the target type
   *
   * @param {ClassConstructorType<T>} target
   * @param {object | null} input
   * @return {T | null}
   */


  Converter.prototype.convertSingle = function (target, input) {
    return this.convertSingleInput(target, input);
  };
  /**
   * Convert a collection of input values into instances of the target type
   *
   * If the input value is an array or an empty value, the result will be an array,
   * otherwise a Map will be returned
   *
   * @param {ClassConstructorType<T>} target
   * @param {I} input
   * @return {T[] | Map<string, T>}
   */


  Converter.prototype.convertCollection = function (target, input) {
    if (Array.isArray(input)) {
      return this.convertArrayCollection(target, input);
    } else if (input) {
      return this.convertObjectCollection(target, input);
    } else {
      return [];
    }
  };
  /**
   * Convert a single raw object into the target type
   *
   * @param {ClassConstructorType<T>} target
   * @param {object | null | string} input
   * @return {T | null}
   */


  Converter.prototype.convertSingleInput = function (target, input) {
    if (!input) {
      return null;
    }

    if (PrimitiveTypeEnum_1.isNotPrimitive(input)) {
      // Create an instance without calling `new`
      var newInstance = Object.create(target.prototype);

      for (var _i = 0, _a = Object.keys(input); _i < _a.length; _i++) {
        var key = _a[_i];
        this.assignProperty(newInstance, key, input);
      }

      if (typeof newInstance['postConstruct'] === 'function') {
        newInstance['postConstruct']();
      }

      return newInstance;
    } else {
      return new target(input);
    }
  };
  /**
   * Convert an array of input values into instances of the target type
   *
   * This method is used to convert an input array
   *
   * @param {ClassConstructorType<T>} target
   * @param {I} input
   * @return {T[]}
   */


  Converter.prototype.convertArrayCollection = function (target, input) {
    var _this = this;

    return map(input, function (item) {
      return _this.convertSingleInput(target, item);
    }).filter(function (i) {
      return null !== i;
    });
  };
  /**
   * Convert a collection of raw object's into the target type
   *
   * This method is used to convert a dictionary input into a Map
   *
   * @param {ClassConstructorType<T>} target
   * @param {I} input
   * @return {Map<string, T>}
   */


  Converter.prototype.convertObjectCollection = function (target, input) {
    var _this = this;

    var targetObject = new Map();

    if (typeof input !== 'object') {
      throw new ConverterTypeError_1.ConverterTypeError("Argument 'input' must be an object, '" + typeof input + "' given");
    }

    Object.keys(input).forEach(function (key) {
      var inputValue = input[key];

      var convertedInstance = _this.convertSingleInput(target, inputValue);

      if (convertedInstance) {
        targetObject.set(key, convertedInstance);
      }
    });
    return targetObject;
  };

  Converter.prototype.assignProperty = function (target, sourceKey, source) {
    var typeDefinition = PropertyTypeDefinition_1.PropertyTypeDefinition.fromObject(target, sourceKey); // Look if there is a Property Type Definition for the source key

    var targetKey = typeDefinition && typeDefinition.propertyKey ? typeDefinition.propertyKey : sourceKey;

    if (typeDefinition) {
      target[targetKey] = this.prepareSourceValue(source, sourceKey, typeDefinition);
    } else {
      this.handleSourcePropertyWithoutDefinition(target, sourceKey, source);
    }
  };

  Converter.prototype.prepareSourceValue = function (source, sourceKey, typeDefinition) {
    var sourceValue = source[sourceKey]; // Handle `null` or `undefined`

    if (sourceValue === null || sourceValue === undefined) {
      return sourceValue;
    }

    var type = typeDefinition.type;

    if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Boolean) {
      return !!sourceValue;
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Number) {
      return parseFloat(sourceValue);
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.String) {
      return '' + sourceValue;
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Null) {
      return null;
    } else if (type === PrimitiveTypeEnum_1.PrimitiveTypeEnum.Undefined) {
      return undefined;
    } else if (undefined === type) {
      return sourceValue;
    } else if (typeDefinition.hasMultiple()) {
      return this.convertCollection(type, sourceValue);
    } else {
      return this.convertSingleInput(type, sourceValue);
    }
  };
  /**
   * If no target key could be detected for sourceKey check if there is a PropertyTypeDefinition
   *
   * @param {T} target
   * @param {string} sourceKey
   * @param source
   */


  Converter.prototype.handleSourcePropertyWithoutDefinition = function (target, sourceKey, source) {
    var sourceValue = source[sourceKey];
    var classTypeDefinition = ClassLevel_1.ClassTypeDefinition.fromObject(target);

    if (!classTypeDefinition || classTypeDefinition.ignoreUnknownFields()) {
      if (this.logger) {
        var message = "Property '" + sourceKey + "' could not be set in '" + target.constructor.name + "': ";

        if (!classTypeDefinition) {
          this.logger.log(message + 'No class type definition found');
        } else if (!classTypeDefinition.ignoreUnknownFields()) {
          this.logger.log(message + 'Unknown fields are ignored');
        }
      }

      return;
    }

    if (classTypeDefinition.denyUnknownFields()) {
      throw new ConverterTypeError_1.ConverterTypeError("Property '" + sourceKey + "' could not be found in '" + Util_1.Util.inspectType(target) + "'");
    }

    if (classTypeDefinition.addUnknownFields()) {
      var newTargetKey = this.detectNewPropertyTargetKey(target, sourceKey);

      if (newTargetKey === null) {
        throw new ConverterTypeError_1.ConverterTypeError("Property '" + sourceKey + "' could not be set in '" + Util_1.Util.inspectType(target) + "'");
      }

      target[newTargetKey] = sourceValue;
    }
  };

  Converter.prototype.detectNewPropertyTargetKey = function (newInstance, sourceKey) {
    if (this.hasPropertyWriteAccess(newInstance, sourceKey)) {
      return sourceKey;
    } else if (this.hasPropertyWriteAccess(newInstance, '_' + sourceKey)) {
      return '_' + sourceKey;
    } else {
      return null;
    }
  };

  Converter.prototype.hasPropertyWriteAccess = function (instance, key) {
    var descriptor = Object.getOwnPropertyDescriptor(instance, key) || Object.getOwnPropertyDescriptor(instance.constructor.prototype, key);

    if (!descriptor) {
      return true;
    } // noinspection RedundantIfStatementJS


    if (descriptor.get && !descriptor.set) {
      return false;
    }

    return true;
  };

  return Converter;
}();

exports.Converter = Converter;